//Utilisé pour le moment uniquement dans la page de controle de facturation
export enum EProfile {
	remplacant = "remplacant",
	titulaire = "titulaire"
}